export default class EventDispatcher {
  constructor(engine) {
    this.engine = engine;
    this.listeners = {};
  }
  // append a handler
  on(type, callback) {
    if (!this.listeners[type]) {
      this.listeners[type] = [];
    }
    let length = this.listeners[type].push(callback);
    // returns object for handler
    return {
      index: length - 1,
      remove: () => {
        this.listeners[type].splice(length - 1, 1);
      },
    };
  }
  // emit an event
  emit(type, value){
      if(this.listeners[type]){
        this.listeners[type].forEach(callback => {
            callback(value);
        });
      }
  }
}